import { DefaultService } from '@/services/DefaultService';

const server = "cockpit-expenses";

export default class CockpitDespesasService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env)
	}

	// getTotalEmDespesas(filtros) {
	// 	let temp = this._http.post(`${this._env}/${server}/total-em-despesas`, filtros, this._headers)
	// 	.then(res => res.body, this.handleError);
	// 	console.log(temp);
	// 	return temp
	// }

	// getDespesasAbertas(filtros) {
	// 	return this._http.post(`${this._env}/${server}/despesas-abertas`, filtros, this._headers)
	// 	.then(res => res.body, this.handleError);
	// }

	// getAdiantamentoEmAberto(filtros) {
	// 	return this._http.post(`${this._env}/${server}/adiantamento-em-aberto`, filtros, this._headers)
	// 	.then(res => res.body, this.handleError);
	// }

	// getDespesasPorColaboradorAbc(filtros) {
	// 	return this._http.post(`${this._env}/${server}/despesas-por-colaborador-abc`, filtros, this._headers)
	// 	.then(res => res.body, this.handleError);
	// }

	// getDespesasPorMotivo(filtros) {
	// 	return this._http.post(`${this._env}/${server}/despesas-por-motivo`, filtros, this._headers)
	// 	.then(res => res.body, this.handleError);
	// }

	getAll(filters) {
		return this._http.post(`${this._env}/${server}/charts.json`, filters, this._headers)
		.then(res => res.body, this.handleError);
	}

	// usado pelo componente de chart
	getChartByTitulo(titulo, filters) {
		return this._http.post(`${this._env}/${server}/chart/${titulo}`, filters, this._headers)
		.then(res => res.body, this.handleError);
	}
}